import React from "react";

const Tank = () => {
  return <div>Tank Page</div>;
};

export default Tank;
